<script setup lang="ts">
import { AvailablePaymentMethods } from '@/Pejer/types/checkout'
import { LoaderCircle } from 'lucide-vue-next'
import { onMounted, ref } from 'vue'

const props = defineProps<{
  paymentReferenceID: string
  paymentMethod: AvailablePaymentMethods
  switchSwedbankPayCheckoutMethod: (
    paymentMethod: AvailablePaymentMethods,
    containerId: string,
    events?: {
      onError?: (data: any) => void
      onEventNotification?: (data: any) => void
      onPaid?: (data: any) => void
    }
  ) => Promise<
    | {
        open: () => void
        close: () => void
        refresh: () => void
        resume: () => void
        update: () => void
      }
    | null
    | undefined
  >
}>()

const isLoading = ref(true)

onMounted(async () => {
  await props.switchSwedbankPayCheckoutMethod(
    props.paymentMethod,
    'swedbank-container-' + props.paymentMethod
  )

  isLoading.value = false
})
</script>
<template>
  <!-- :id="'swedbank-' + props.paymentMethod" -->
  <div :id="'swedbank-container-' + props.paymentMethod" class="w-full" />
  <div v-if="isLoading" class="w-full h-32 flex items-center justify-center">
    <span class="text-gray-500"
      ><LoaderCircle class="w-20 h-20 text-slate-700 animate-spin" stroke-width="1.5" />
    </span>
  </div>
</template>
